import { api } from './api';

/** Read-selected-content-aloud (spec 046 FR-017). */
export async function narrateText(text: string): Promise<string> {
  const response = await api.post<{ data: { audioDataUri: string } }>('/api/gn/narrate', { text });
  return response.data.data.audioDataUri;
}
